import React, { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import i18next from "i18next";
import AddEditTransport from "../AddEditTransport";
import PrepareDataTable from "./PrepareDataTable";
import { TransportListContainer, Title } from "./TransportList.styled";
import "./TransportList.scss";

/**
 * Site List,
 * Path - /sites
 * @see See [Sites Requirements](https://hesusstore.atlassian.net/wiki/spaces/HS/pages/3412230147/Administration+-+Transport+types)
 * @component
 */
const TransportList = (props) => {
  const { t, columnList, countries } = props;

  const [isRefreshList, setIsRefreshList] = useState(false);
  const [isAddTransportPopupVisible, setAddTransportPopupVisible] =
    useState(false);
  const updateRefeshStatus = () => {
    setIsRefreshList(true);
  };

  const createNewTransport = () => {
    setAddTransportPopupVisible(true);
  };

  const closeTransportCreationPopup = () => {
    setAddTransportPopupVisible(false);
  };

  useEffect(() => {
    if (isRefreshList) {
      setIsRefreshList(false);
    }
  }, [isRefreshList]);

  return (
    <TransportListContainer className="transport-list">
      <Title>{t("TRANSPORT_TYPES")}</Title>
      <PrepareDataTable
        isRefreshList={isRefreshList}
        columnList={columnList}
        updateRefeshStatus={updateRefeshStatus}
        createNewTransport={createNewTransport}
        countries={countries}
      />
      {isAddTransportPopupVisible && (
        <AddEditTransport
          title={t("TRANSPORT_TYPE_NEW")}
          onClose={closeTransportCreationPopup}
          updateRefeshStatus={updateRefeshStatus}
        />
      )}
    </TransportListContainer>
  );
};

TransportList.propTypes = {
  t: PropTypes.func.isRequired,
  columnList: PropTypes.arrayOf(PropTypes.string),
};

TransportList.defaultProps = {
  columnList: [],
};

export default withTranslation()(TransportList);
